var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.btnClass,attrs:{"id":_vm.id,"title":_vm.title,"x-small":"","icon":""},on:{"click":function($event){return _vm.action(_vm.actionParams)}}},[_c('v-icon',{class:_vm.icon})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }